import React from 'react';
import HomeButton from './common/navigation/HomeButton';
import './ReleaseNotes.css';

const ReleaseNotes = () => {
  const releases = [
    {
      version: "1.6.0",
      date: "2026-10-18",
      majorUpdates: [
        "Ao5 and ao12 on timer stats and Practice Analysis are now trimmed averages of unrounded times. Shown values can change for solves already stored.",
        "Attempt counts on timer stats and Practice Analysis now follow the event log. Shown counts can change for solves already stored."
      ],
      minorUpdates: [],
      bugFixes: [],
      knownIssues: [
        "Mobile view is not optimized for maximum screen size",
        "Mobile elements are misaligned on some devices"
      ]
    },
    {
      version: "1.5.0",
      date: "2024-12-06",
      majorUpdates: [
        "Improved data structure for algorithm tracking"
      ],
      minorUpdates: [
        "Improved logging for better debugging (visible in web console)"
      ],
      bugFixes: [
        "Fixed issue where algorithm attempts weren't properly separated by mode",
        "Fixed missing cases reappearing after being executed"
      ],
      knownIssues: [
        "Mobile view is not optimized for maximum screen size",
        "Mobile elements are misaligned on some devices"
      ]
    },
    {
      version: "1.4.0",
      date: "2024-12-05",
      majorUpdates: [],
      minorUpdates: [
        "Added Release Notes page with first release notes",
        "Added HOW TO GET STARTED Button"
      ],
      bugFixes: [
        "Fixed issue where 'Cases Needing Data' section wasn't updating",
        "Fixed issue where execution attempts were not being stored"
      ],
      knownIssues: [
        "Mobile view is not optimized for maximum screen size",
        "Mobile elements are misaligned on some devices"
      ]
    },
  ];

  return (
    <div className="release-notes">
      <div className="header-container">
        <h1>Release Notes</h1>
        <HomeButton />
      </div>

      {releases.map((release) => (
        <div key={release.version} className="release">
          <h2>Version {release.version} <span className="release-date">({release.date})</span></h2>
          
          {release.majorUpdates.length > 0 && (
            <section>
              <h3>Major Updates</h3>
              <ul>
                {release.majorUpdates.map((update, index) => (
                  <li key={index}>{update}</li>
                ))}
              </ul>
            </section>
          )}

          {release.minorUpdates.length > 0 && (
            <section>
              <h3>Minor Updates</h3>
              <ul>
                {release.minorUpdates.map((update, index) => (
                  <li key={index}>{update}</li>
                ))}
              </ul>
            </section>
          )}

          {release.bugFixes.length > 0 && (
            <section>
              <h3>Bug Fixes</h3>
              <ul>
                {release.bugFixes.map((fix, index) => (
                  <li key={index}>{fix}</li>
                ))}
              </ul>
            </section>
          )}

          {release.knownIssues.length > 0 && (
            <section>
              <h3>Known Issues</h3>
              <ul>
                {release.knownIssues.map((issue, index) => (
                  <li key={index}>{issue}</li>
                ))}
              </ul>
            </section>
          )}
        </div>
      ))}
    </div>
  );
};

export default ReleaseNotes; 